import StoreTags from '@enums/StoreTags'
import { ItemsFromResponse } from '@models/common'
import { MintrudDict, MintrudDictOption } from '@models/mintrudDict'
import { HYDRA_MEMBER, HYDRA_TOTAL_ITEMS } from '../../config/consts'
import emptySplitApi from '../api'

const BASE_URL = '/api/mintrud-dict'

export const mintrudDictApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getMintrudDict: builder.query<
      { items: MintrudDictOption[]; length: number },
      { search?: string; pagination?: boolean }
    >({
      providesTags: [StoreTags.MINTRUD_DICT],
      query: (params) => ({
        url: BASE_URL,
        params,
      }),
      transformResponse: (response: ItemsFromResponse<MintrudDict>) => ({
        items: response[HYDRA_MEMBER].map((item) => ({
          ...item,
          value: item['@id'],
          label: `${item.id} ${item.name}`,
        })),
        length: response[HYDRA_TOTAL_ITEMS],
      }),
    }),
  }),
})

export const { useGetMintrudDictQuery } = mintrudDictApi
